export default {

    data(){
        return {
            modals:{

            }

        }
    },
    computed:{
    },
    methods: {
        openModal({ modalName, data, callback }) {
            let modal = this.modals[modalName];
            if (!modal) {
                throw {
                    code: 422,
                    message: this.$t("the_modal_does_not_exist"),
                };
            }
            modal.data = {
                ...modal.data,
                ...data
            }
            modal.show = true;
            if(callback) callback(modal);
        },
        closeModal({ modalName, callback }) {
            if(this.modalDefined(modalName)){
                if(callback) callback(this.modals[modalName]);
                this.modals[modalName].show = false;
            }
            
        },

        modalDefined(modalName) {
            if(!modalName && !this.modals[modalName]) return false;
            return true;
        }

    }
}